import { Injectable } from "@angular/core";
import { ApiHttpService } from "./api-http.service";
import { Observable } from "rxjs";

@Injectable()
export class RequestPurposeService {
  constructor(private apiHttp: ApiHttpService) {}

  public getAll = (): Observable<RequestPurpose[]> => {
    return this.apiHttp.get<RequestPurpose[]>("requestpurposes");
  };

  public get = (id: number): Observable<RequestPurpose> => {
    return this.apiHttp.get<RequestPurpose>(`requestpurposes/${id}`);
  };
}

export interface RequestPurpose {
  id: number;
  name: string;
  isActive: boolean;
}

export enum RequestPurposeType {
  BiomassInFlats = 1,
  BiomassInPots = 2,
  PollinationAndImmatureHarvest = 3,
  PollinationAndMatureHarvest = 4,
  Donors = 5
}



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-4/_work/202/s/src/app/shared/services/request-purpose.service.ts